import Vue from 'vue';

export class TrackingHandler {
  static getModalInfo(modalId) {
    const modalElement = document.getElementById(modalId);

    return {
      element: modalElement,
      goalPath: '/virtual/signup/',
      modalDescription: modalElement.dataset.modalDescription,
      modalHeader: modalElement.dataset.modalHeader,
      modalImage: modalElement.dataset.modalImage,
      modalName: modalElement.dataset.modalName,
      modalTags: modalElement.dataset.modalTags,
      modalTest: modalElement.dataset.modalTest,
      modalTestStartDate: modalElement.dataset.modalTestStartDate,
      modalCampaignName: modalElement.dataset.modalCampaignName,
      pageTitle: document.body.dataset.pageTitle,
      pageUid: document.body.dataset.pageUid,
      pathName: window.location.href.replace(/\?.*/, '').replace(/\#.*/, ''),
      payload: `${ modalElement.dataset.modalName } - Modal ${ modalElement.dataset.modalTest }`,
    };
  }

  static exitModalShown(modalId) {
    if (typeof GTM === 'undefined') return;

    const modalInfo = TrackingHandler.getModalInfo(modalId);
    TrackingHandler.sendToGTM(modalInfo);
  }

  static sendToGTM(modalInfo, modalAction = '') {
    if (typeof GTM === 'undefined') return;

    const eventName = (modalAction === 'submit') ? 'modal-submit' : 'modal-impression';

    const variables = {
      'hitType': 'pageview',
      'page': modalInfo.goalPath + modalAction,
      'dimension1': modalInfo.modalName,
      'dimension2': modalInfo.pathName,
      'dimension3': JSON.stringify([
        modalInfo.modalTest,
        modalInfo.modalTestStartDate,
        modalInfo.modalTags,
        modalInfo.pageUid,
      ]),
      'dimension4': modalInfo.modalHeader,
      'dimension5': modalInfo.modalDescription,
      'dimension6': modalInfo.modalImage,
      'dimension7': modalInfo.pageTitle,
    };

    const data = Object.assign({}, { event: eventName }, variables);
    GTM.push(data);
  }

  static trackEvent(modalId, eventName) {
    if (Vue.prototype.exitModalHandler) {
      Vue.prototype.exitModalHandler.hideModal();
    }

    const modalInfo = TrackingHandler.getModalInfo(modalId);
    TrackingHandler.sendToGTM(modalInfo, eventName);
  }
}

export default {
  install: function(Vue) {
    Vue.prototype.trackingHandler = TrackingHandler;
  },
};
